import Component from '../core/Component'
import Support from '../utils/BrowserSupport'

const STATUS = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible'
}

export default class FlashMessages extends Component {

    prepare() {
        this.timer = setTimeout(::this.hide, 3000)
        this.element.addEventListener(Support.transitionEnd, () => {
            if (!this.is(STATUS.ACTIVE)) {
                this.element.classList.remove(STATUS.VISIBLE)
            }
        })
    }

    destroy() {
        clearTimeout(this.timer)
    }

    hide() {
        this.element.classList.remove(STATUS.ACTIVE)
    }
}